import script from "./GenericButton.vue?vue&type=script&setup=true&lang=js"
export * from "./GenericButton.vue?vue&type=script&setup=true&lang=js"

import "./GenericButton.vue?vue&type=style&index=0&id=597da76b&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-597da76b"]])

export default __exports__